/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_DeletedInputs */

const en_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset deleted successfully`)
};

const fr_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prereglage supprime avec succes`)
};

const de_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung erfolgreich gelöscht`)
};

const it_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione eliminata con successo`)
};

const ru_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно настроенные параметры успешно удалены.`)
};

const es_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste eliminado exitosamente`)
};

const zh_cn2_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预设已成功删除`)
};

const ja_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが正常に削除されました`)
};

const hi_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_video_export_preset_deleted = /** @type {(inputs: Video_Export_Preset_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinição excluída com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset deleted successfully" |
*
* @param {Video_Export_Preset_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_deleted = /** @type {((inputs?: Video_Export_Preset_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_deleted(inputs)
	if (locale === "de") return de_video_export_preset_deleted(inputs)
	if (locale === "it") return it_video_export_preset_deleted(inputs)
	if (locale === "ru") return ru_video_export_preset_deleted(inputs)
	if (locale === "es") return es_video_export_preset_deleted(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_deleted(inputs)
	if (locale === "ja") return ja_video_export_preset_deleted(inputs)
	if (locale === "hi") return hi_video_export_preset_deleted(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_deleted(inputs)
	return en_video_export_preset_deleted(inputs)
});